(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__vpMoreInit) return;
    window.__vpMoreInit = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vp-more-open]');
      if (opener) {
        var dlg = opener.parentElement.querySelector('.vp-more-dialog');
        if (dlg && typeof dlg.showModal === 'function') {
          dlg.showModal();
          var sel = dlg.querySelector('.vp-more-row.is-selected, .vp-more-card.is-selected');
          if (sel) sel.scrollIntoView({ block: 'nearest' });
        }
        return;
      }

      if (e.target.closest('[data-vp-more-close]')) {
        var d = e.target.closest('dialog');
        if (d) d.close();
        return;
      }

      var pick = e.target.closest('[data-vp-pick]');
      if (pick) {
        var dialog = pick.closest('dialog');
        var fieldset = pick.closest('fieldset') || pick.closest('variant-picker');
        var input = fieldset && fieldset.querySelector('input[data-option-value-id="' + pick.dataset.vpPick + '"]');
        if (dialog) dialog.close();
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (e.target instanceof HTMLDialogElement && e.target.classList.contains('vp-more-dialog')) {
        e.target.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["guide-installation"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__guideModalInit) return;
    window.__guideModalInit = true;

    var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    var WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
    var modal;

    function useNativeViewer() {
      return navigator.pdfViewerEnabled === true && window.matchMedia('(min-width: 750px)').matches;
    }

    function loadPdfJs() {
      if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = PDFJS;
        s.onload = function () {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER;
          resolve(window.pdfjsLib);
        };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function build() {
      modal = document.createElement('dialog');
      modal.className = 'guide-modal';
      modal.innerHTML =
        '<div class="guide-modal__bar">' +
        '<a class="guide-modal__full" target="_blank" rel="noopener">Plein écran ↗</a>' +
        '<button type="button" class="guide-modal__close" aria-label="Fermer">' +
        '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button></div>' +
        '<div class="guide-modal__notice" role="note" hidden>' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13 2L4 14h7l-1 8 9-12h-7z"/></svg>' +
        '<p style="margin:0"><strong class="guide-modal__notice-title"></strong> <span class="guide-modal__notice-text"></span></p>' +
        '</div><div class="guide-modal__body"></div>';
      document.body.appendChild(modal);
      modal.querySelector('.guide-modal__close').addEventListener('click', close);
      modal.addEventListener('click', function (e) {
        if (e.target === modal) close();
      });
      modal.addEventListener('close', function () {
        modal.querySelector('.guide-modal__body').innerHTML = '';
        document.documentElement.style.overflow = '';
      });
    }

    function close() {
      if (modal && modal.open) modal.close();
    }

    function renderPages(url, body) {
      var wrap = document.createElement('div');
      wrap.className = 'guide-modal__pages';
      var loading = document.createElement('div');
      loading.className = 'guide-modal__loading';
      loading.textContent = 'Chargement du guide…';
      var inner = document.createElement('div');
      inner.className = 'guide-modal__inner';
      wrap.appendChild(inner);
      body.appendChild(wrap);
      body.appendChild(loading);
      enableZoom(wrap, inner, body);
      loadPdfJs()
        .then(function (lib) {
          return lib.getDocument(url).promise;
        })
        .then(function (pdf) {
          var width = wrap.clientWidth - 24;
          var chain = Promise.resolve();
          for (var i = 1; i <= pdf.numPages; i++) {
            (function (n) {
              chain = chain.then(function () {
                return pdf.getPage(n).then(function (page) {
                  if (!modal.open) return;
                  var base = page.getViewport({ scale: 1 });
                  var px = Math.min(2400, Math.max(width * (window.devicePixelRatio || 1) * 2, 1800));
                  var vp = page.getViewport({ scale: px / base.width });
                  var canvas = document.createElement('canvas');
                  canvas.width = vp.width;
                  canvas.height = vp.height;
                  inner.appendChild(canvas);
                  if (n === 1) loading.remove();
                  return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise;
                });
              });
            })(i);
          }
          return chain;
        })
        .catch(function () {
          loading.innerHTML = '';
          var a = document.createElement('a');
          a.href = url;
          a.target = '_blank';
          a.rel = 'noopener';
          a.style.color = '#fff';
          a.textContent = 'Ouvrir le guide';
          loading.appendChild(a);
        });
    }

    function enableZoom(wrap, inner, body) {
      var MIN = 1, MAX = 4, zoom = 1, start = null, lastTap = 0;

      function setZoom(z, cx, cy) {
        z = Math.max(MIN, Math.min(MAX, z));
        var rect = wrap.getBoundingClientRect();
        var fx = cx - rect.left, fy = cy - rect.top;
        var px = (wrap.scrollLeft + fx) / zoom, py = (wrap.scrollTop + fy) / zoom;
        zoom = z;
        inner.style.setProperty('--guide-zoom', z);
        wrap.scrollLeft = px * z - fx;
        wrap.scrollTop = py * z - fy;
      }

      function dist(t) {
        return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY);
      }

      wrap.addEventListener('touchstart', function (e) {
        if (e.touches.length === 2) {
          start = { d: dist(e.touches), z: zoom };
        } else if (e.touches.length === 1) {
          var now = Date.now();
          if (now - lastTap < 300) {
            e.preventDefault();
            var t = e.touches[0];
            setZoom(zoom > 1.2 ? 1 : 2.5, t.clientX, t.clientY);
            lastTap = 0;
          } else {
            lastTap = now;
          }
        }
      }, { passive: false });

      wrap.addEventListener('touchmove', function (e) {
        if (!start || e.touches.length !== 2) return;
        e.preventDefault();
        var t = e.touches;
        setZoom(start.z * (dist(t) / start.d), (t[0].clientX + t[1].clientX) / 2, (t[0].clientY + t[1].clientY) / 2);
      }, { passive: false });

      wrap.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) start = null;
      });

      wrap.addEventListener('wheel', function (e) {
        if (!e.ctrlKey) return;
        e.preventDefault();
        setZoom(zoom * (e.deltaY < 0 ? 1.1 : 0.9), e.clientX, e.clientY);
      }, { passive: false });

      if (window.matchMedia('(pointer: coarse)').matches) {
        var hint = document.createElement('div');
        hint.className = 'guide-modal__hint';
        hint.textContent = 'Pincez pour zoomer';
        body.appendChild(hint);
        setTimeout(function () { hint.style.opacity = '0'; }, 2500);
        setTimeout(function () { hint.remove(); }, 3000);
      }
    }

    function open(url, link) {
      if (!modal) build();
      var notice = modal.querySelector('.guide-modal__notice');
      var nt = link.getAttribute('data-guide-notice-title') || '';
      var nx = link.getAttribute('data-guide-notice-text') || '';
      modal.querySelector('.guide-modal__notice-title').textContent = nt;
      modal.querySelector('.guide-modal__notice-text').textContent = nx;
      notice.hidden = !(nt || nx);
      var body = modal.querySelector('.guide-modal__body');
      body.innerHTML = '';
      modal.querySelector('.guide-modal__full').href = url;
      if (useNativeViewer()) {
        var frame = document.createElement('iframe');
        frame.className = 'guide-modal__frame';
        frame.title = "Guide d'installation";
        frame.src = url + (url.indexOf('#') === -1 ? '#view=FitH' : '');
        body.appendChild(frame);
      } else {
        renderPages(url, body);
      }
      document.documentElement.style.overflow = 'hidden';
      modal.showModal();
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-guide-open]');
      if (!link || typeof HTMLDialogElement === 'undefined') return;
      e.preventDefault();
      open(link.getAttribute('data-guide-url'), link);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
